import { createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        primary: {
            main: '#f7aa45',
        },
    },
});

export default theme;
